"use strict";
/* globals module */
/**
 * @module articleInstanceTagsRoute
 * @description Baasic Article Instance Tags Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Instance Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var ArticleInstanceTagsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceTagsRoute, _super);
    function ArticleInstanceTagsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{articleId}/tags/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'articles/{articleId}/tags/{tag}/{?embed,fields}';
        _this.createRoute = 'articles/{articleId}/tags/{tag}/';
        _this.deleteRoute = 'articles/{articleId}/tags/{id}';
        _this.deleteAllRoute = 'articles/{articleId}/tags';
        return _this;
    }
    /**
     * Parses find article tags route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article tags using the phrase search; multiple tag keywords must be comma separated.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article tag subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article tag property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resources need to be retrieved.
     * @param options Query resource options object.
     * @example articleInstanceTagsRoute.find().expand({searchQuery: '<search-phrase>'});
     **/
    ArticleInstanceTagsRoute.prototype.find = function (articleId, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resource needs to be retrieved.
     * @param id A slug or id which uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleInstanceTagsRoute.get({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.get = function (articleId, id, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses create article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag value that needs to be inserted as new article tag resource into the system.
     * @example articleInstanceTagsRoute.create({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data Article Tag object that needs to be removed from the system.
     * @example articleInstanceTagsRoute.delete({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data Article object whoose tags needs to be removed from the system.
     * @example articleInstanceTagsRoute.deleteAll({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.deleteAll = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteAllRoute, data, undefined, 'delete-tags-by-article');
    };
    var _a;
    ArticleInstanceTagsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceTagsRoute);
    return ArticleInstanceTagsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceTagsRoute = ArticleInstanceTagsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 
